// extracted by mini-css-extract-plugin
export default {"appIcon":"search-page__appIcon__Ppm7u","titleWrapper":"search-page__titleWrapper__P1yXt","title":"search-page__title__xN1rg","productCount":"search-page__productCount__wPsWH"};